import React from "react"

import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword"
import ResetPassword from "pages/Auth/ResetPassword"
import OrderDashboard3 from "pages/OrderDashboard3/OrderDashboard"
import Login3 from "pages/AuthenticationInner/Login3"
import LocationManagement from "pages/Location-Mngt"
import AcceptAppointment from "pages/AcceptAppointment"
import AddLocationMapping from "pages/AddLocationMapping"
import Notification from "pages/Notification"
import UserAdmin from "pages/UserManagement"
import CreateUser from "pages/UserManagement/CreateUser"
import ReqScheduler from "pages/ReqScheduler"
import LocationConfiguration from "pages/LocationConfiguration"
import OpenDockLocationConfig from "pages/LocationConfiguration/OpenDockLocationConfig"
import TenantCustomisation from "pages/TenantCustomisation"
import AuthCode from "pages/Auth/AuthCode"
import CognitoIdp from "pages/Cognito-IDP"
import AuthorizationConfig from "pages/Cognito-IDP/AuthorizationConfig"
import AuthGrantFlow from "pages/Cognito-IDP/AuthGrantFlow"
import ClientCredGrantFlow from "pages/Cognito-IDP/ClientCredGrantFlow"
import SAMLEditForm from "pages/Cognito-IDP/SAMLEditForm"
import EmailTemplate from "pages/EmailTemplate"
import EmailAddressConfig from "pages/EmailAddressConfig"
import NewLocation from "pages/NewLocation"
import EmailLocationMapping from "pages/EmailLocationMapping"
import ApptReqEmailTemplate from "pages/ApptReqEmailTemplate"
import CreateTemplate from "pages/ApptReqEmailTemplate/CreateTempalte"
import TemplateDetails from "pages/ApptReqEmailTemplate/TemplateDetails"
import TemplateData from "pages/ApptReqEmailTemplate/TemplateData"
import CloneTemplate from "pages/ApptReqEmailTemplate/CloneTemplate"
import SystemConfiguration from "pages/SystemConfiguration"
import OpenDockTemplate from "pages/OpenDockLocMapping/OpenDockTemplate"
import OpenDockLocMapping from "pages/OpenDockLocMapping"
import OpenDockWarehouse from "pages/OpenDockWarehouse"
import MasterLocation from "pages/MasterLocation"
import AppointmentSystemCreds from "pages/ApptSysCreds"
import EmailApptReport from "pages/EmailApptReport"
import QuedLogin from "pages/AuthenticationInner/QuedLogin"
import { components } from "react-select"
import OpenDockLocConfig from "pages/OpenDockLocConfig"
import TemplateConfig from "pages/OpenDockLocConfig/TemplateMapping"
import LocationConfig from "pages/OpenDockLocConfig/LocationConfig"
import ApptReqCfg from "pages/ApptReqCfg/List"
import ApptReqCfgDetailsPage from "pages/ApptReqCfg/Details"
import LocationMapImport from "pages/LocationMapImport"

const authProtectedRoutes = [
  { path: "/dashboard", component: <OrderDashboard3 /> },
  { path: "/location-management", component: <LocationManagement /> },
  { path: "/stop-accept-appointment", component: <AcceptAppointment /> },
  { path: "/add-location-mapping", component: <AddLocationMapping /> },
  { path: "/user-admin", component: <UserAdmin /> },
  { path: "/notification", component: <Notification /> },
  { path: "/create-user", component: <CreateUser /> },
  {
    path: "/req-scheduler",
    component: <ReqScheduler />,
  },
  {
    path: "/loc-config-open-dock",
    component: <LocationConfiguration />,
  },
  {
    path: "/loc-config-open-dock/:locationId/:locationName",
    component: <OpenDockLocationConfig />,
  },
  {
    path: '/tenant-customisation',
    component: <TenantCustomisation />
  },
  {
    path: '/auth-config',
    component: <AuthorizationConfig />
    // component: <CognitoIdp />
  },

  {
    path: '/auth-config/code',
    component: <AuthGrantFlow />
  },
  {
    path: '/auth-config/new',
    component: <CognitoIdp />
  },
  {
    path: '/auth-config/clientcred',
    component: <ClientCredGrantFlow />
  },
  {
    path:'/auth-config-saml/new',
    component: <SAMLEditForm />

  },
  {
    path:'/email-template',
    component: <EmailTemplate />
  }, 
  {
    path:'/opendock-template',
    component: <OpenDockTemplate />
  },
  {
    path: '/email-address-config/:locationId/:locationName',
    component: <EmailAddressConfig />
  }, 
  {
    path: '/new-location-email',
    component: <EmailLocationMapping />
  },
  {
    path: '/new-location',
    component: <NewLocation />
  },
  {
    path: '/email-templates',
    component: <ApptReqEmailTemplate />
  },
  {
    path: '/create-email-template',
    component: <CreateTemplate />
  },
  {
    path: '/email-template/view/:name',
    component: <TemplateData />
  },
  {
    path: '/email-template/clone/:name',
    component: <CloneTemplate />
  }, {
    path: '/system-configuration',
    component: <SystemConfiguration />
  },
  {
    path: '/opendock-loc/',
    //component: <OpenDockLocMapping />
    component: <OpenDockLocConfig />
  },
  {
    path: '/opendock-loc/config/:m_loc_id/:location_name',
    component: <LocationConfig />
  },
  {
    path: '/opendock-loc/template-config/:m_loc_id',
    component: <TemplateConfig />
  },
  {
    path: '/opendock-loc1/',
    component: <OpenDockLocMapping />
  },
  {
    path: '/opendock-warehouse/:locationId/:locationName',
    component: <OpenDockWarehouse />
  },
  {
    path: '/master-loc',
    component: <MasterLocation />
  }, 
  {
    path: '/appt-sys',
    component: <AppointmentSystemCreds />
  },
  {
    path: '/email-appt-report',
    component: <EmailApptReport />
  },
  {
    path: '/appt-req-cfg',
    component: <ApptReqCfg />
  },
  {
    path: '/appt-req-cfg/:apptSysType',
    component: <ApptReqCfgDetailsPage />
  },
  {
    path: '/loc-map-import',
    component: <LocationMapImport />
  }



 
]

const publicRoutes = [
  // { path: "/", component: <Login3 /> },
  { path: "/", component: <QuedLogin /> },
  { path: "/resetpassword", component: <ResetPassword /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  {
    path: "/auth", component:<AuthCode />

  }
]

export { authProtectedRoutes, publicRoutes }
